import { Form, Select } from "antd";

import requiredRule from "../../../../../utils/formRules/requiredRule";
import { TemplateType } from "../../types";
import { useGetCtaImageQuery } from "../../../../../graphql/operations/trialMode/caringCTA/get-CTA-image";

export function FormItemImage({
  selectedTemplate,
}: {
  selectedTemplate: TemplateType;
}) {
  const { data } = useGetCtaImageQuery();
  
  const selectedOptionRenderer = (option: any) => {
    return (
      <div className="flex items-center gap-2 mt-[1px]">
        <img
          src={option.imageFileURL}
          alt={option.imageFileName}
          className="w-7 h-7"
        />
        <p>{option.imageFileName}</p>
      </div>
    );
  };

  const customOptionRenderer = (option: any) => {
    return (
      <div className="flex items-center gap-4">
        <img
          src={option.imageFileURL}
          alt={option.imageFileName}
          className="w-16 h-16"
        />
        <p>{option.imageFileName}</p>
      </div>
    );
  };

  return (
    <Form.Item
      name="imageCharacter"
      label="Image"
      className={selectedTemplate === "Image" ? "" : "hidden"}
      rules={selectedTemplate === "Image" ? [requiredRule] : undefined}
    >
      <Select
        optionLabelProp="custom"
        dropdownRender={(menu) => <div>{menu}</div>}
          >
        {data?.wf_trialModeLeads_designImage?.edges?.map((option) => (
          <Select.Option
            key={option.node.imageFileName}
            value={option.node.imageFileName}
            custom={selectedOptionRenderer(option.node)}
            children={customOptionRenderer(option.node)}
          />
        ))}
      </Select>
    </Form.Item>
  );
}
